'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/utils/shad';
import type { ReactNode } from 'react';
type SegmentPickerRowProps = {
  children: ReactNode;
  trailing?: ReactNode;
  className?: string;
};

/** Standalone picker row used on dedicated segment pages (e.g. Team). */
export function SegmentPickerRow(t0) {
  const $ = _c(6);
  const {
    children,
    trailing,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex min-w-0 flex-nowrap items-center gap-3 border-b border-b-lightborder px-8 py-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1 || $[4] !== trailing) {
    t2 = <div className={t1}>{children}{trailing}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = trailing;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
type SegmentScopeSegmentControlsProps = {
  picker: ReactNode;
  trailing?: ReactNode;
  showLeadingDivider?: boolean;
};

/** Picker controls embedded to the right of scope tabs (All / Team / …). */
export function SegmentScopeSegmentControls(t0) {
  const $ = _c(6);
  const {
    picker,
    trailing,
    showLeadingDivider: t1
  } = t0;
  const showLeadingDivider = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== showLeadingDivider) {
    t2 = showLeadingDivider ? <div className="h-5 w-px shrink-0 bg-border" aria-hidden={true} /> : null;
    $[0] = showLeadingDivider;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== picker || $[3] !== t2 || $[4] !== trailing) {
    t3 = <>{t2}{picker}{trailing}</>;
    $[2] = picker;
    $[3] = t2;
    $[4] = trailing;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}